import { SettingsSubModule } from '../utils/settings-sub-module';
import { SettingValue } from '../utils/setting-value';
import { SettingsModule } from '../utils/settings-module';

export namespace InstitutionalReviewBoardFields {
  export enum ModuleField {
    NoDocumentsForApprovedIrb = 'InstitutionalReviewBoard.NoDocumentsForApprovedIrb',
  }
}

class ModuleConfig extends SettingsSubModule {
  @SettingsSubModule.value(InstitutionalReviewBoardFields.ModuleField.NoDocumentsForApprovedIrb, false)
  noDocumentsForApprovedIrb: SettingValue<boolean>;
}

export class InstitutionalReviewBoardModule extends SettingsModule {
  @SettingsModule.value(ModuleConfig) common: ModuleConfig;
}
